import React, { useState, useEffect, useMemo, useRef, useCallback, useContext } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import Select from "react-select";
import redirectURL from "../redirectURL";

import XLSX from "xlsx/dist/xlsx.full.min.js";
import SweetAlert from 'react-bootstrap-sweetalert';
import { LoadingPortContext, resolvePageAccess } from "../../context/LoadingPortContext";
import { getCellValue, findByFieldIgnoreCase, isSameIgnoreCase } from "../common/utils";
// 🔘 Toggle Renderer (Yes / No)

const ToggleRenderer = (props) => {
    const value = !!props.value;

    const onToggle = () => {
        props.node.setDataValue(props.colDef.field, !value);
    };

    return (
        <div
            onClick={onToggle}
            style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                width: "100%",
                height: "100%"
            }}
        >
            {/* Switch */}
            <div
                style={{
                    width: "36px",
                    height: "18px",
                    borderRadius: "20px",
                    background: value ? "#22c55e" : "#cbd5e1",
                    position: "relative",
                    transition: "0.2s"
                }}
            >
                <div
                    style={{
                        width: "14px",
                        height: "14px",
                        borderRadius: "50%",
                        background: "#fff",
                        position: "absolute",
                        top: "2px",
                        left: value ? "18px" : "2px",
                        transition: "0.2s"
                    }}
                />
            </div>

            {/* Label */}
            <span style={{ fontSize: "12px", fontWeight: 500 }}>
                {value ? "Yes" : "No"}
            </span>
        </div>
    );
};

const OrderDayMaster = () => {
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);
    const days = useMemo(
        () => [
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday"
        ],
        []
    );
    const [selectedRows, setSelectedRows] = useState([])
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const [formData, setFormData] = useState({

    });
    const [editIndex, setEditIndex] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);
    const [showSlider, setShowSlider] = useState(false);
    const [uniqueConsigneeData, setUniqueConsigneeData] = useState([]);
    // 📊 Sample Data
    const [orderDayData, setOrderDayData] = useState([])
    const [counters, setCounters] = useState({ activeConsignees: 0, inactiveConsignees: 0 })
    const [changedData, setChangedData] = useState({});




    const [rowData, setRowData] = useState([]);
    const originalRowDataRef = useRef([]);

    // 📋 Column Definitions

    const components = {

        toggleRenderer: ToggleRenderer
    };

    const columnDefs = useMemo(() => {
        return [
            {
                headerName: "Consignee Name",
                field: "consignee_name",
                pinned: "left",
                width: 190
            },
            {
                headerName: "Consignee Code",
                field: "consignee_code",
                pinned: "left",
                width: 150,
                cellStyle: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }
            },
            ...days.map((day) => ({
                headerName: day.charAt(0).toUpperCase() + day.slice(1),
                field: day,
                cellRenderer: "toggleRenderer",
                width: 130,
                cellStyle: {
                    display: "flex",
                    // justifyContent: "center",
                    alignItems: "center"
                }, flex: 1
            }))
        ];
    }, [days]);

    const gridRef = useRef();

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    const closeAlert = () => {
        setShow(false)
    }
    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var port = await pageAccessFn();
            await getNecessaryData(port);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);
    const pageAccessFn = useCallback(async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            return resolved.loading_port_code;
        } catch (err) {
            console.log(err);
        }

    }, [portContext]);

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await getNecessaryData(selectedPlant);
        setValidData([]);
        setErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };
    const getNecessaryData = async (port) => {
        // await getHubData({ is_active: 1, loading_port_code: port })
        const consigneeData = await getConsigneeData({ loading_port_code: port, status: 1 });
        const orderDayData = await getOrderDayData({ loading_port_code: port, status: 1 })
        await getMappingRowData(consigneeData, orderDayData);
        const { active, inactive } = getConsigneeCounters(consigneeData, orderDayData);
        setCounters({

            activeConsignees: active,
            inactiveConsignees: inactive
        });

    }

    const getConsigneeData = async (data) => {
        try {
            var params = data;
            const response = await redirectURL.post("/lmconsignees/getUniqueLmConsignees", params);
            if (response.data.status == "success") {
                const uniqueData = [
                    ...new Map(response.data.data.map(item => [item.consignee_code, item])).values()
                ];
                setUniqueConsigneeData(uniqueData)
                return uniqueData
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleDeleteSelected = async (port) => {
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        var payload = selectedRows.map((each) => {
            return {
                loading_port_code: each.loading_port_code,
                hub_name: each.hub_name,
                consignee_city: each.consignee_city,
                state: each.state,
                vehicle_capacity: formData.vehicle_capacity,
                is_active: 1
            }
        })
        setLoadshow("show-m")
        setOverly("show-m")
        // await deleteHubConsigneeData(payload)
        // await getHubConsigneeData(port);
        setLoadshow("show-n")
        setOverly("show-n")
    }



    const getOrderDayData = async (data) => {
        try {
            var params = data;
            const response = await redirectURL.post("/lmconsignees/getOrderDayData", params);
            if (response.data.status == "success") {
                setOrderDayData(response.data.data)
                return response.data.data
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({

        });
        setShowBulkSlider(false)
        setValidData([])
        setErrors([])
        setFileName("")
    };
    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };

    // ================= VALIDATION =================


    const validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        console.log(data)

        data.forEach((row, index) => {

            const rowNumber = index + 2; // Excel row (header = 1)

            let consigneeCodeInput = String(getCellValue(row, "Consignee Code") || "").trim();
            const isYes = (value) => String(value || "").trim().toUpperCase() === "YES";
            const isProvided = (value) => String(value || "").trim() !== "";
            const matchedConsignee = findByFieldIgnoreCase(uniqueConsigneeData, "consignee_code", consigneeCodeInput);
            let consigneeCode = matchedConsignee ? matchedConsignee.consignee_code : consigneeCodeInput;
            const existingRow = (rowData || []).find((each) => isSameIgnoreCase(each.consignee_code, consigneeCode)) || {};
            // Days left blank in the uploaded file keep their existing value instead of being reset to "No".
            const resolveDay = (headerKey, dayKey) => isProvided(getCellValue(row, headerKey)) ? isYes(getCellValue(row, headerKey)) : !!existingRow[dayKey];
            let sunday = resolveDay("Sunday", "sunday");
            let monday = resolveDay("Monday", "monday");
            let tuesday = resolveDay("Tuesday", "tuesday");
            let wednesday = resolveDay("Wednesday", "wednesday");
            let thursday = resolveDay("Thursday", "thursday");
            let friday = resolveDay("Friday", "friday");
            let saturday = resolveDay("Saturday", "saturday");
            let rowErrors = [];


            if (!matchedConsignee) {
                rowErrors.push(`Consignee Code - "${consigneeCodeInput}" does not exist in available Consignees.`);
            }

            // ---- Collect Errors ----
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                cleanedData.push({
                    consignee_name: matchedConsignee.consignee_name,
                    consignee_code: consigneeCode,
                    "sunday": sunday,
                    "monday": monday,
                    "tuesday": tuesday,
                    "wednesday": wednesday,
                    "thursday": thursday,
                    "friday": friday,
                    "saturday": saturday,

                });
            }
        });

        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }

        setErrors(errorList);
        setValidData(cleanedData);

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };

    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")
        setValidData([])
        setErrors([])
        setFileName("")
    }

    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = validData.length == 0
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    const getMappingRowData = (consigneeData, orderDayData) => {
        const orderMap = new Map();

        orderDayData.forEach((e) => {
            orderMap.set(e.consignee_code, e);
        });
        const days = [
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday"
        ];
        const rowData = consigneeData.map((each) => {
            const object = orderMap.get(each.consignee_code) || {};

            const mapped = {
                consignee_name: each.consignee_name,
                consignee_code: each.consignee_code
            };

            days.forEach((day) => {
                mapped[day] = object[day] ? object[day] : false;
            });

            return mapped;
        });

        originalRowDataRef.current = rowData.map((each) => ({ ...each }));
        setRowData(rowData);
    };
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData.map((each) => {
                return (
                    {
                        ...each
                    }
                )
            })
            console.log(validData, finalData)

            await updateOrderDayData(finalData)
            await getNecessaryData(loadingPortCode);
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setFileName("")

            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };
    const updateOrderDayData = async (array) => {
        // console.log(object)
        const matchedPort = loadingPortData.find((each) => each.value == loadingPortCode);
        var params = {
            data: array,
            loading_port_code: loadingPortCode,
            comp_short_name: (matchedPort && matchedPort.label) || "",
            comp_code: compCode,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        try {

            const response = await redirectURL.post("/lmconsignees/updateOrderDayData", params);
            if (response.data.message == "Success") {
                // setRowData(response.data.hubData || [])
                setShow(true)
                setBasicType("success")
                setBasicTitle("Updated Succesfully")
            } else {
                setShow(true)
                setBasicType("danger")
                setBasicTitle(response.data.message || "Update failed. Please try again.")
            }
        } catch (error) {
            console.log(error)
            var errMessage = (error && error.response && error.response.data && error.response.data.message) || "Update failed. Please try again.";
            setShow(true)
            setBasicType("danger")
            setBasicTitle(errMessage)
        }
    }
    const getConsigneeCounters = (consigneeData, orderDayData) => {
        let active = 0;
        let inactive = 0;

        const days = [
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday"
        ];

        orderDayData.forEach((row) => {
            let isActive = false;

            for (let i = 0; i < days.length; i++) {
                if (row[days[i]] === true) {
                    isActive = true;
                    break;
                }
            }

            if (isActive) {
                active++;
            } else {
                inactive++;
            }
        });
        return { active, inactive: (inactive + (consigneeData.length - orderDayData.length)) };
    };
    const onCellValueChanged = (params) => {
        const { data, colDef } = params;
        console.log(data)
        const field = colDef.field;

        setChangedData((prev) => {
            const existing = prev[data.consignee_code] || {};

            return {
                ...prev,
                [data.consignee_code]: {
                    // ...existing,
                    ...data,
                    [field]: data[field]

                }
            };
        });

    };
    const onSyncData = async () => {
        const array = Object.values(changedData);
        const hasActualChange = array.some((row) => {
            const original = originalRowDataRef.current.find((r) => r.consignee_code === row.consignee_code);
            if (!original) return true;
            return days.some((day) => !!original[day] !== !!row[day]);
        });
        if (!hasActualChange) {
            setChangedData({});
            setShow(true);
            setBasicType("warning");
            setBasicTitle("No Changes Made.");
            return;
        }
        await updateOrderDayData(array);
        setChangedData({});
        await getNecessaryData(loadingPortCode);
    }
    // console.log(changedData)
    const isDirty = Object.keys(changedData).length > 0;
    const onExportClick = () => {
        if (gridRef.current && gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            gridRef.current.api.exportDataAsExcel({
                fileName: "order_day_master.xlsx",
                // columnKeys: ['consignee_code', 'Sunday', 'Monday', 'Tuesday'], // export specific columns
                // onlySelected: false, // export selected rows only
            });
        }
    };
    return (
        <div className="hub-master-container d-flex flex-column p-3" style={{ height: "100%" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                styles={{ zIndex: "10000001" }}
            >
            </SweetAlert>

            <div className="master-header">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Order Day Master</h5>
                </div>

                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <CounterCards
                        active={counters.activeConsignees}
                        inactive={counters.inactiveConsignees}
                    />
                    <div className="d-flex justify-content-end align-items-center" style={{ gap: "8px" }}>
                        {selectedRows.length > 0 && <button
                            className="pill-btn pill-btn-danger"
                            onClick={() => { handleDeleteSelected(loadingPortCode) }}
                            disabled={selectedRows.length == 0}
                        >
                            Delete Selected
                        </button>}
                        <button
                            className="pill-btn pill-btn-primary"
                            onClick={() => {
                                onExportClick();
                            }}
                        >
                            Export Data
                        </button>
                        {isDirty && <button
                            className="pill-btn" style={{ backgroundColor: "#f57c00", color: "#fff" }}
                            onClick={() => {
                                onSyncData();
                            }}
                        >
                            Sync Data
                        </button>}
                        <button
                            className="pill-btn pill-btn-success"
                            onClick={() => {
                                setErrors([]);
                                setValidData([]);
                                setFileName("");
                                setShowBulkSlider(true);
                            }}
                        >
                            Import Data
                        </button>
                    </div>
                </div>
            </div>

            <div className="ag-theme-balham grid-wrapper px-2 mt-2" style={{ flexGrow: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}

                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "center" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    sideBar={{
                        toolPanels: [
                            {
                                id: 'columns',
                                labelDefault: 'Columns',
                                iconKey: 'columns',
                                toolPanel: 'agColumnsToolPanel'
                            },
                            {
                                id: 'filters',
                                labelDefault: 'Filters',
                                iconKey: 'filter',
                                toolPanel: 'agFiltersToolPanel'
                            }
                        ],
                        // defaultToolPanel: 'filters'
                    }}
                    animateRows rowSelection={"multiple"}
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onCellValueChanged={onCellValueChanged}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }} suppressRowClickSelection={true}
                />
            </div>
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Import Data
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <a href={require("../../assets/orderdaymaster.xlsx")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                            Download Sample Template
                        </a>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}


                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                    <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Submit only valid data" : "Submit"}
                    </button>
                </div>

            </div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ zIndex: 100 }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>
        </div>
    );
};

export default OrderDayMaster;

const CounterCards = ({ active, inactive }) => {
    return (
        <div style={{ display: "flex", gap: "10px" }}>

            {/* Active */}
            <div
                className="d-flex align-items-center"
                style={{
                    gap: "8px",
                    padding: "6px 14px",
                    borderRadius: "999px",
                    background: "#ecfdf5",
                    border: "1px solid #bbf7d0"
                }}
            >
                <span style={{ fontSize: "12px", fontWeight: 600, color: "#166534", whiteSpace: "nowrap" }}>
                    Scheduled
                </span>
                <span style={{ fontSize: "15px", fontWeight: 700, color: "#15803d" }}>
                    {active}
                </span>
            </div>

            {/* Inactive */}
            <div
                className="d-flex align-items-center"
                style={{
                    gap: "8px",
                    padding: "6px 14px",
                    borderRadius: "999px",
                    background: "#fef2f2",
                    border: "1px solid #fecaca"
                }}
            >
                <span style={{ fontSize: "12px", fontWeight: 600, color: "#7f1d1d", whiteSpace: "nowrap" }}>
                    Not Scheduled
                </span>
                <span style={{ fontSize: "15px", fontWeight: 700, color: "#dc2626" }}>
                    {inactive}
                </span>
            </div>

        </div>
    );

};